import { Box, Typography } from '@mui/material';
import { useStylesProductPageUXB } from '../SharedStyles/SharedStyles';
import { ValueProperties } from 'types/Products';

interface Props {
  requirements: ValueProperties[];
}
export const StorageRequirements: React.FC<Props> = ({ requirements }) => {
  const { classes } = useStylesProductPageUXB();

  return (
    <Box className={classes.productInformationGrid}>
      <Typography
        variant="h3"
        sx={{
          color: 'GrayText'
        }}
      >
        Storage Requirements
      </Typography>
      <ul>
        {requirements.map(requirement => (
          <Typography key={requirement.value} component={'li'} sx={{ mt: 1 }}>
            {requirement?.value}
          </Typography>
        ))}
      </ul>
    </Box>
  );
};
